import { Controller } from "@hotwired/stimulus"

// Triggers animation classes when elements enter the viewport
// Usage: data-controller="scroll-animate"
//        data-scroll-animate-class-value="nd-animate-fade-up"
//        data-scroll-animate-threshold-value="0.15"
//        data-scroll-animate-once-value="true"
export default class extends Controller {
  static values = {
    class: { type: String, default: "nd-animate-fade-up" },
    threshold: { type: Number, default: 0.15 },
    once: { type: Boolean, default: true },
    delay: { type: Number, default: 0 }
  }

  connect() {
    // Respect reduced motion preference
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      this.element.classList.remove("nd-animate-hidden")
      this.element.classList.add(this.classValue)
      return
    }

    this.observer = new IntersectionObserver(
      this.handleIntersect.bind(this),
      {
        threshold: this.thresholdValue,
        rootMargin: "0px 0px -50px 0px"
      }
    )
    
    this.observer.observe(this.element)
  }

  handleIntersect(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        if (this.delayValue > 0) {
          setTimeout(() => {
            this.animate()
          }, this.delayValue)
        } else {
          this.animate()
        }
        
        if (this.onceValue) {
          this.observer.disconnect()
        }
      } else if (!this.onceValue) {
        this.element.classList.remove(this.classValue)
        this.element.classList.add("nd-animate-hidden")
      }
    })
  }

  animate() {
    this.element.classList.remove("nd-animate-hidden")
    this.element.classList.add(this.classValue)
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }
}
